export const yellow = {
  yellow1: "#CE9C27",
  yellow2: "#D8A631",
  yellow3: "#DEB554",
  yellow4: "#E5C476",
  yellow5: "#EBD298",
};
